const pending = new Map<string, Promise<any>>();
const TTL_MS = 5000;
/**
 * Deduplicates concurrent API calls with the same key.
 * If two callers invoke this simultaneously, they share the same Promise
 * and only one actual HTTP request is made.
 * Once the request settles, the cache is cleared so the next call starts fresh.
 */
export function deduplicate<T>(key: string, request: () => Promise<T>): Promise<T> {
    if (!pending.has(key)) {
        const promise = request().finally(() => {
            setTimeout(() => pending.delete(key), TTL_MS);
        });
        pending.set(key, promise);
    }
    return pending.get(key)! as Promise<T>;
}
